import React from "react";
import { Phone } from "lucide-react";

// Sticky bottom action bar — mobile only
export default function MobileActionBar() {
  const scrollToQuote = () => {
    const el = document.getElementById("quote");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 sm:hidden grid grid-cols-2 shadow-2xl">
      <a
        href="tel:+14794227180"
        onClick={() => {
          if (typeof window.gtag === "function") {
            window.gtag("event", "contact_phone", {
              event_category: "engagement",
              event_label: "Mobile Action Bar Phone",
            });
          }
        }}
        className="flex items-center justify-center gap-2 py-4 bg-[hsl(var(--navy))] text-white font-heading text-lg tracking-wider active:bg-[hsl(var(--navy))]/90"
      >
        <Phone size={20} />
        Call Now
      </a>
      <button
        onClick={() => {
          if (typeof window.gtag === "function") {
            window.gtag("event", "request_estimate", {
              event_category: "engagement",
              event_label: "Mobile Action Bar CTA",
            });
          }
          scrollToQuote();
        }}
        className="flex items-center justify-center gap-2 py-4 bg-[hsl(var(--accent))] text-white font-heading text-lg tracking-wider active:bg-[hsl(var(--accent))]/90"
      >
        Free Estimate
      </button>
    </div>
  );
}